import { Checkbox as MUICheckbox } from '@mui/material';

import { Link } from 'Components/Buttons/Buttons';
import { Text } from 'Components/Text/Text';
import { FormFieldTooltip } from 'Components/Tooltips/FormFieldTooltip';

import styles from './Checkbox.module.css';

interface CheckboxProps {
    checked: boolean;
    label: string;
    onToggled: (isChecked: boolean) => void;

    disabled?: boolean;
    labelLinkDestination?: string;
    tooltip?: string;
}

/**
 * Renders a checkbox and a label. The label will be rendered as a link if `labelLinkDestination` is provided.
 * The main responsibility of this component is to visually indicate when the checkbox is disabled, by graying out the checkbox and label.
 * TODO: Improve accessibility. Checkboxes should be able to be accessed via a label that is semantically associated with the checkbox input.
 */
export const Checkbox = (props: CheckboxProps) => {
    return (
        <div className={styles.checkboxContainer}>
            <MUICheckbox
                checked={props.checked}
                onChange={(event: React.FormEvent<HTMLInputElement>) => {
                    props.onToggled(event.currentTarget.checked);
                }}
                disabled={props.disabled}
                sx={props.disabled ? { color: 'var(--hps-gray) !important' } : { color: 'var(--hps-dark-blue) !important' }}
            />
            {props.labelLinkDestination ? (
                <Link size="sm" to={props.labelLinkDestination}>
                    {props.label}
                </Link>
            ) : (
                <Text noStyles color={props.disabled ? 'darkGray' : undefined}>
                    {props.label}
                </Text>
            )}
            {props.tooltip && <FormFieldTooltip text={props.tooltip} />}
        </div>
    );
};
